import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { saveProfile } from '../../../redux/reducers/profileSlice';
import CropperCom from './CropperCom';
import inputErrors from '../../helpers/validation'
import Loader from '../../helpers/Loader';
import CouplePreview from './Previews/Couple/CouplePreview';

const BG_DETAILS_FIELDS = [
    "sectionHeading",
    "groomFullName",
    "groomParents",
    "groomGrandParents",
    "brideFullName",
    "brideParents",
    "brideGrandParents",
    "groomParentsPrefix",
    "groomGrandParentsPrefix",
    "brideParentsPrefix",
    "brideGrandParentsPrefix"
];

const BrideGroomForm = ({ onBack, onNext }) => {
  const formRef = useRef(null);
  const dispatch = useDispatch()
  // const { user } = useSelector((state) => state.auth)
  const { weddingData: profileData, loading } = useSelector((state) => state.profile)
  const [showGroomParentPrefix, setShowGroomParentPrefix] = useState(false);
  const [showGroomGrandParentPrefix, setShowGroomGrandParentPrefix] = useState(false);

  const [showBrideParentPrefix, setShowBrideParentPrefix] = useState(false);
  const [showBrideGrandParentPrefix, setShowBrideGrandParentPrefix] = useState(false);

  const [values, setValues] = useState({
    sectionHeading: "",
    displayOrder: "",
    coupleType: "",
    groomFullName:"",
     groomParents:"",
     groomParentsPrefix:"",
     groomGrandParents:"",
     groomGrandParentsPrefix:"",
      groomImage:{
        public_id:"",
        url:""
      },
       brideFullName:"",
     brideParents:"",
     brideParentsPrefix:"",
     brideGrandParents:"",
     brideGrandParentsPrefix:"",
      brideImage:{
        public_id:"",
        url:""
      },
})
  const [isSubmitting, setSubmitting] = useState(false);
  const [showCropper, setShowCropper] = useState(false)
  const [errors, setErrors] = useState({})
  const [imageType, setImageType] = useState("")
 
  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault()
     const validationErrors = inputErrors(
        values,
        BG_DETAILS_FIELDS
    );
    setErrors(validationErrors)
    setSubmitting(true)
  }

  useEffect(() => {
    if (isSubmitting) {
      const noErrors = Object.keys(errors).length === 0;
      if (noErrors) {
        savedata()
      } else {
        formRef.current.scrollIntoView({ behavior: "smooth" });
      }

    }
  }, [isSubmitting, errors])

  const savedata = () => {
    setSubmitting(false)
    dispatch(saveProfile({ values, onNext }))
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

 useEffect(() => {
        setValues({ ...profileData })
    }, [profileData])

  const handleCropper = () => setShowCropper(prevValue => !prevValue)

  const opencropper = (imageType) => {
    setImageType(imageType)
    handleCropper()
  }
  if (loading) {
    return <Loader />
  }


  const groomDetailsFeild = () => {
    return (
      <>
        <h3 className={`details-form-heading ${values.displayOrder === "brideFirst" ? "extra-head-padd" : ""
          }`}>Groom Details:</h3>
        <div className={errors.groomFullName ? "form-input-div-error" : "form-input-div"}>
          <input type="search"
            name="groomFullName"
            value={values.groomFullName}
            onChange={handleChange}
            placeholder=' '
            className={errors.groomFullName ? "form-input-field-error" : "form-input-field"}
          />
          <label>Full Name <span style={{ color: "red" }}> *</span></label>
        </div>
        <div className='error-wedding-div'>  {errors.groomFullName && (<small className="error-msg-wedding">{errors.groomFullName}</small>)}</div>

        <span className='extra-label-detail'>Parents Name (optional)</span>
        <div className={errors.groomParents ? "form-input-div-error" : "form-input-div"}>
          <input type="search"
            name="groomParents"
            value={values.groomParents}
            onChange={handleChange}
            placeholder=' '
            className={errors.groomParents ? "form-input-field-error" : "form-input-field"}
          />
          <label>[Eg (Father Name & Mother Name)]</label>
        </div>

        <div className="prefix-container">

          <span className="prefix-text">
            Prefix: <strong>{values.groomParentsPrefix || "S/O"}</strong>
          </span>

          <button
            type="button"
            className="prefix-edit-btn"
            onClick={() => setShowGroomParentPrefix(!showGroomParentPrefix)}
          >
            Customize Prefix
          </button>

        </div>

        {showGroomParentPrefix && (
          <div className="prefix-edit-box">

            <input
              type="text"
              className="prefix-input"
              placeholder="Enter Prefix"
              value={values.groomParentsPrefix}
              name="groomParentsPrefix"
              onChange={handleChange}
            />

            <div className="prefix-btns">

              <button
                type="button"
                className="prefix-save"
                onClick={() => setShowGroomParentPrefix(false)}
              >
                Save
              </button>

              <button
                type="button"
                className="prefix-cancel"
                onClick={() => setShowGroomParentPrefix(false)}
              >
                Cancel
              </button>

            </div>

          </div>
        )}
        <div className='error-wedding-div'>  {errors.groomParents && (<small className="error-msg-wedding">{errors.groomParents}</small>)}</div>
          <div className='error-wedding-div'>  {errors.groomParentsPrefix && (<small className="error-msg-wedding">{errors.groomParentsPrefix}</small>)}</div>
     
        <span className='extra-label-detail'>Grand Parents Name (optional)</span>
        <div className={errors.groomGrandParents ? "form-input-div-error" : "form-input-div"}>
          <input type="search"
            name="groomGrandParents"
            value={values.groomGrandParents}
            onChange={handleChange}
            placeholder=' '
            className={errors.groomGrandParents ? "form-input-field-error" : "form-input-field"}
          />
          <label>[Eg (Grand Father Name & Mother Name)]</label>
        </div>
        <div className="prefix-container">

          <span className="prefix-text">
            Prefix: <strong>{values.groomGrandParentsPrefix || "GS/O"}</strong>
          </span>

          <button
            type="button"
            className="prefix-edit-btn"
            onClick={() => setShowGroomGrandParentPrefix(!showGroomGrandParentPrefix)}
          >
            Customize Prefix
          </button>

        </div>

        {showGroomGrandParentPrefix && (
          <div className="prefix-edit-box">

            <input
              type="text"
              className="prefix-input"
              placeholder="Enter Prefix"
              value={values.groomGrandParentsPrefix}
              name="groomGrandParentsPrefix"
              onChange={handleChange}
            />

            <div className="prefix-btns">

              <button
                type="button"
                className="prefix-save"
                onClick={() => setShowGroomGrandParentPrefix(false)}
              >
                Save
              </button>

              <button
                type="button"
                className="prefix-cancel"
                onClick={() => setShowGroomGrandParentPrefix(false)}
              >
                Cancel
              </button>

            </div>

          </div>
        )}
        <div className='error-wedding-div'>  {errors.groomGrandParents && (<small className="error-msg-wedding">{errors.groomGrandParents}</small>)}</div>
         <div className='error-wedding-div'>  {errors.groomGrandParentsPrefix && (<small className="error-msg-wedding">{errors.groomGrandParentsPrefix}</small>)}</div>
       
        {values.coupleType==="photoCouple"  && <button
          type="button"
          className={`default-banner-button  ${values.displayOrder === "brideFirst" ? "extra-head-padd-bottom" : ""} `}
          onClick={() => opencropper("groomImage")}
        >
          Upload Groom Photo
        </button> }
        
      </>
    )
  }

  const brideDetailsFeild = () => {
    return (
      <>
        <h3 className={`details-form-heading ${values.displayOrder === "groomFirst" ? "extra-head-padd" : ""
          }`}>Bride Details:</h3>
        <div className={errors.brideFullName ? "form-input-div-error" : "form-input-div"}>
          <input type="search"
            name="brideFullName"
            value={values.brideFullName}
            onChange={handleChange}
            placeholder=' '
            className={errors.brideFullName ? "form-input-field-error" : "form-input-field"}
          />
          <label>Full Name<span style={{ color: "red" }}> *</span></label>
        </div>
        <div className='error-wedding-div'>  {errors.brideFullName && (<small className="error-msg-wedding">{errors.brideFullName}</small>)}</div>

        <span className='extra-label-detail'>Parents Name (optional)</span>
        <div className={errors.brideParents ? "form-input-div-error" : "form-input-div"}>
          <input type="search"
            name="brideParents"
            value={values.brideParents}
            onChange={handleChange}
            placeholder=' '
            className={errors.brideParents ? "form-input-field-error" : "form-input-field"}
          />

          <label>[Eg (Father Name & Mother Name)]</label>
        </div>
        <div className="prefix-container">

          <span className="prefix-text">
            Prefix: <strong>{values.brideParentsPrefix || "D/O"}</strong>
          </span>

          <button
            type="button"
            className="prefix-edit-btn"
            onClick={() => setShowBrideParentPrefix(!showBrideParentPrefix)}
          >
            Customize Prefix
          </button>

        </div>

        {showBrideParentPrefix && (
          <div className="prefix-edit-box">

            <input
              type="text"
              className="prefix-input"
              placeholder="Enter Prefix"
              value={values.brideParentsPrefix}
              name="brideParentsPrefix"
              onChange={handleChange}
            />

            <div className="prefix-btns">

              <button
                type="button"
                className="prefix-save"
                onClick={() => setShowBrideParentPrefix(false)}
              >
                Save
              </button>

              <button
                type="button"
                className="prefix-cancel"
                onClick={() => setShowBrideParentPrefix(false)}
              >
                Cancel
              </button>

            </div>

          </div>
        )}
        <div className='error-wedding-div'>  {errors.brideParents && (<small className="error-msg-wedding">{errors.brideParentDetail}</small>)}</div>
         <div className='error-wedding-div'>  {errors.brideParentsPrefix && (<small className="error-msg-wedding">{errors.brideParentsPrefix}</small>)}</div>
 
        <span className='extra-label-detail'>Grand Parents Name(optional)</span>
        <div className={errors.brideGrandParents ? "form-input-div-error" : "form-input-div"}>
          <input type="search"
            name="brideGrandParents"
            value={values.brideGrandParents}
            onChange={handleChange}
            placeholder=' '
            className={errors.brideGrandParents ? "form-input-field-error" : "form-input-field"}
          />
          <label>[Eg (Grand Father Name & Mother Name)]</label>
        </div>
        <div className="prefix-container">

          <span className="prefix-text">
            Prefix: <strong>{values.brideGrandParentsPrefix || "GD/O"}</strong>
          </span>

          <button
            type="button"
            className="prefix-edit-btn"
            onClick={() => setShowBrideGrandParentPrefix(!showBrideGrandParentPrefix)}
          >
            Customize Prefix
          </button>

        </div>

        {showBrideGrandParentPrefix && (
          <div className="prefix-edit-box">

            <input
              type="text"
              className="prefix-input"
              placeholder="Enter Prefix"
              value={values.brideGrandParentsPrefix}
              name="brideGrandParentsPrefix"
              onChange={handleChange}
            />

            <div className="prefix-btns">

              <button
                type="button"
                className="prefix-save"
                onClick={() => setShowBrideGrandParentPrefix(false)}
              >
                Save
              </button>

              <button
                type="button"
                className="prefix-cancel"
                onClick={() => setShowBrideGrandParentPrefix(false)}
              >
                Cancel
              </button>

            </div>

          </div>
        )}
        <div className='error-wedding-div'>  {errors.brideGrandParents && (<small className="error-msg-wedding">{errors.brideGrandParentDetail}</small>)}</div>
        <div className='error-wedding-div'>  {errors.brideGrandParentsPrefix && (<small className="error-msg-wedding">{errors.brideGrandParentsPrefix}</small>)}</div>

       {values.coupleType==="photoCouple" &&  <button
          type="button"
          className={`default-banner-button  ${values.displayOrder === "groomFirst" ? "extra-head-padd-bottom" : ""} `}
          onClick={() => opencropper("brideImage")}
        >
          Upload Bride Photo
        </button> }
       
      </>
    )
  }


  return (
   <>
    <div className="form-screen">
      <div className="container mb-3">

        <div
          className={`row d-flex row-containers mx-2 ${
            values.theme === "theme2" ? "theme2-row" : ""
          }`}
        >

          {/* FORM */}
          <div
            className={
              values.theme === "theme2"
                ? "col-lg-6 col-md-6 form-container"
                : "col-lg-6 col-md-12 form-container"
            }
          >
            <h3 className="form-heading">Groom and Bride Details</h3>

            <form
              className="form-div"
              onSubmit={handleSubmit}
              ref={formRef}
            >

              <div className="display-order-container">
                <label>Do you have groom and bride photo?</label>

                <div className="display-radios">
                  <label>
                    <input
                      type="radio"
                      name="coupleType"
                      value="photoCouple"
                      checked={values.coupleType === "photoCouple"}
                      onChange={handleChange}
                      style={{ marginRight: "5px" }}
                    />
                    Yes
                  </label>

                  <label>
                    <input
                      type="radio"
                      name="coupleType"
                      value="noPhotoCouple"
                      checked={values.coupleType === "noPhotoCouple"}
                      onChange={handleChange}
                      style={{ marginRight: "5px" }}
                    />
                    No
                  </label>
                </div>
              </div>

              <div
                className={
                  errors.sectionHeading
                    ? "form-input-div-error"
                    : "form-input-div"
                }
              >
                <input
                  type="search"
                  name="sectionHeading"
                  value={values.sectionHeading}
                  onChange={handleChange}
                  placeholder=" "
                  className={
                    errors.sectionHeading
                      ? "form-input-field-error"
                      : "form-input-field"
                  }
                />

                <label>Section heading (Optional)</label>
              </div>

              <div className="error-wedding-div">
                {errors.sectionHeading && (
                  <small className="error-msg-wedding">
                    {errors.sectionHeading}
                  </small>
                )}
              </div>

              {values.displayOrder === "groomFirst" ? (
                <>
                  {groomDetailsFeild()}
                  {brideDetailsFeild()}
                </>
              ) : (
                <>
                  {brideDetailsFeild()}
                  {groomDetailsFeild()}
                </>
              )}

              <div className="form-double-buttons">
                <button type="button" onClick={onBack}>
                  Back
                </button>

                <button type="submit">
                  Save
                </button>
              </div>

            </form>
          </div>

          {/* PREVIEW */}
          <div
            className={
              values.theme === "theme2"
                ? values.coupleType === "photoCouple"
                  ? "col-lg-5 col-md-6 preview-container-bg photo-couple-preview theme2-preview"
                  : "col-lg-5 col-md-6 preview-container-bg nophoto-couple-preview theme2-preview"
                : values.coupleType === "photoCouple"
                  ? "col-md-12 preview-container-bg photo-couple-preview"
                  : "col-md-12 preview-container-bg nophoto-couple-preview"
            }
          >
            <CouplePreview
              values={values}
            theme={values?.theme}
            />
          </div>

        </div>
      </div>

      {showCropper && (
        <CropperCom
          handleCropper={handleCropper}
          setValues={setValues}
          values={values}
          imageType={imageType}
        />
      )}
    </div>
  </>
  )
}

export default BrideGroomForm